'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
require('./device.context-f96381a3.js');
require('./mobile-detect-2421ba00.js');
var device_styles = require('./device.styles-facac80d.js');

var StatusTitleWrapper = styled__default.div(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 12px;\n  align-items: center;\n\n  ", "\n"], ["\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 12px;\n  align-items: center;\n\n  ",
    "\n"])), device_styles.mediaMaxWidth(styled.css(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n    margin-bottom: 16px;\n  "], ["\n    margin-bottom: 16px;\n  "])))));
var StatusTitle = styled__default.div(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  font: 700 24px/24px ", ";\n  color: ", ";\n  margin-right: 8px;\n"], ["\n  font: 700 24px/24px ", ";\n  color: ", ";\n  margin-right: 8px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.fontColor;
});
var IconWrapper = styled__default.div(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  padding: 6px;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  padding: 6px;\n"])));
var BackgroundIcon = styled__default.div(templateObject_5 || (templateObject_5 = tslib_es6.__makeTemplateObject(["\n  background-color: ", ";\n  opacity: 0.2;\n  border-radius: 50%;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n"], ["\n  background-color: ", ";\n  opacity: 0.2;\n  border-radius: 50%;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.admin.green;
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;

var StatusIconTitle = function (_a) {
    var title = _a.title, icon = _a.icon, hideIcon = _a.hideIcon, className = _a.className;
    return (React__default.createElement(StatusTitleWrapper, { className: className },
        React__default.createElement(StatusTitle, { "data-cy": "icon-status-title", "data-test-id": "icon-status-testid" }, title),
        !hideIcon && (React__default.createElement(IconWrapper, { "data-test-id": "icon-wrapper-testid" },
            React__default.createElement(BackgroundIcon, null),
            icon))));
};
StatusIconTitle.defaultProps = {
    icon: React__default.createElement(React__default.Fragment, null),
    hideIcon: false,
    className: '',
};

exports.StatusIconTitle = StatusIconTitle;
